const Btn =({value})=>{
    return(
        <>
        <button className="px-[20px] py-[10px] bg-teal-500 rounded-[5px] mt-4 font-semibold">{value}</button>
        </>
    )
}
export default Btn;